// Lib
import React from 'react';
import { NavLink } from 'react-router-dom';

const SPACER_INSERT_INDEX = 3;

const getLinkLabel = (title, totalCountInCart) => {
  if (title !== 'Cart') {
    return title;
  }
  return totalCountInCart ? `${title}(${totalCountInCart})` : title;
};

const HeaderLinks = ({
  HEADER_LINKS,
  classes,
  cx,
  isDesktopMode,
  isTabletMode,
  onCloseSideMenu,
  pathname,
  totalCountInCart,
}) => (
  <div className={classes.linkContainer}>
    {HEADER_LINKS.map(({ path, title, icon: Icon, id }, index) => [
      !isDesktopMode && index === SPACER_INSERT_INDEX && (
        <div className={classes.spacer} key={`${title}_${index}`} />
      ),
      <NavLink
        className={({ isActive }) =>
          isActive ? cx(classes.link, classes.activeLink) : classes.link
        }
        onClick={isTabletMode && onCloseSideMenu} // to close sidebar on click to the active menu item
        key={id}
        to={path}
        state={{
          navigateFrom: pathname,
        }}
        id={id}>
        <Icon className={classes.icon} />
        {getLinkLabel(title, totalCountInCart)}
      </NavLink>,
    ])}
  </div>
);

export default HeaderLinks;
